import { defaultStore } from 'app/gamma/src/defaultStore';
import { featureFlagClient } from '@trello/feature-flag-client';
import {
  setHeaderBrandingColor,
  removeHeaderBrandingColor,
  setHeaderBrandingLogo,
  removeHeaderBrandingLogo,
  setHeaderBrandingName,
  removeHeaderBrandingName,
} from 'app/gamma/src/modules/state/ui/header';

interface HeaderOptions {
  headerBrandingColor?: string;
  headerBrandingLogo?: string;
  headerBrandingName?: string;
}

export const headerBranding = (opts: HeaderOptions) => {
  const isCorporateVisEnabled = featureFlagClient.get(
    'enterprise.corporate-visibility',
    false,
  );
  const isHeaderBrandingEnabled =
    featureFlagClient.get('enterprise.branding', false) &&
    !isCorporateVisEnabled;

  if (opts.headerBrandingName && isCorporateVisEnabled) {
    defaultStore.dispatch(setHeaderBrandingName(opts.headerBrandingName));
  } else {
    defaultStore.dispatch(removeHeaderBrandingName());
  }

  if (opts.headerBrandingLogo && isHeaderBrandingEnabled) {
    defaultStore.dispatch(setHeaderBrandingLogo(opts.headerBrandingLogo));
  } else {
    defaultStore.dispatch(removeHeaderBrandingLogo());
  }

  if (opts.headerBrandingColor && isHeaderBrandingEnabled) {
    defaultStore.dispatch(setHeaderBrandingColor(opts.headerBrandingColor));
  } else {
    defaultStore.dispatch(removeHeaderBrandingColor());
  }
};
